module.exports = __webpack_public_path__ + "static/media/RP_Villafrance.e82740d1.jpg";